
const Iletisim = () => {
  return (
       <>
      <div className="row justify-content-center mb-4 pt-4 pb-4">
        <div className="col-md-5 col-sm-12 d-flex flex-column">
          <h2 className="header-hero-contact pb-4">POLSAN Teknokent</h2>

          <div className="row justify-content-between mb-4">
            <div className="col mt-4">
              <p>POLSAN Technology Development Zone is being established in the Tuzla - Akfırat region of Istanbul. It is located 2 km from the Northern Marmara Highway, 10 km from Sabiha Gökçen Airport, 25 km from the Osman Gazi Bridge, and 35 km from the Fatih Sultan Mehmet Bridge.</p>
            </div>
          </div>

          <div className="row justify-content-between mt-auto">
            <div className="google-map col">
              <iframe src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d6029.646844692592!2d29.4210195!3d40.9196174!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDU1JzEwLjciTiAyOcKwMjUnMjIuNiJF!5e0!3m2!1sen!2str!4v1768227614455!5m2!1sen!2str" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
        
        <div className="col-md-1"></div>
        <div className="col-md-1 border-start"></div>
        
        <div className="col-md-5 col-sm-12 d-flex flex-column">
          <h2 className="header-hero-contact pb-4">POLSAN S&T Park HQ</h2>

          <div className="row justify-content-between mb-4">
            <div className="col mt-4 pb-1">
              <p className="mb-0"><i className="bi bi-pin-map-fill"></i> Ünalan Mahallesi Libadiye Caddesi No: 84 34700 </p>
              <p className="mb-1 text-end">Üsküdar / İSTANBUL</p>
              <p className="mb-1"><i className="bi bi-telephone-fill"></i> <a href="tel:+902162101842">+90 216 210 18 42</a></p>
              <p className="mb-1"><i className="bi bi-envelope-fill"></i> <a href="mailto:info@polsanteknokent.com.tr" aria-label="info@polsanteknokent.com.tr adresine e-posta gönder">info@polsanteknokent.com.tr</a></p>
            </div>
          </div>

          <div className="row justify-content-between mt-auto">
            <div className="google-map col">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.1356508020917!2d29.068104090130312!3d41.000404046052054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac7dc2527cb6f%3A0x78c0b47807d519ac!2zw5xuYWxhbiwgTGliYWRpeWUgQ2QuIE5vOjg0LCAzNDcwMCDDnHNrw7xkYXIvxLBzdGFuYnVs!5e0!3m2!1sen!2str!4v1758793992255!5m2!1sen!2str" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </div>

    </>

  );
};

export default Iletisim;
